import { HttpErrorResponse } from '@angular/common/http';
import { createFeature, createReducer, on } from '@ngrx/store';
import { DerivativeSearchProduct, DerivativeSearchValue, LeverageProductType } from '@zero/shared/util-models';
import { CAPS, DERIVATIVE_TYPES, DURATIONS, FACTORS, STRIKES } from '../entities/defaults';
import { DerivativeType } from '../entities/derivative.type';
import { DerivativeSearchActions, DerivativeSearchApiActions } from './derivative-search.actions';

export const DERIVATIVE_SEARCH_FEATURE_KEY = 'derivativeSearch';

export interface DerivativeSearchState {
  isin: string;
  error: HttpErrorResponse | null;
  products: DerivativeSearchProduct[];
  loading: boolean;
  derivativeType: DerivativeType;
  leverage: number;
  cap: DerivativeSearchValue;
  strike: DerivativeSearchValue;
  duration: DerivativeSearchValue;
  factor: DerivativeSearchValue;
  quickMode: boolean;
  productType: LeverageProductType;
  customLeverage: number;
  highlightedProduct: DerivativeSearchProduct;
}

export const initialState: DerivativeSearchState = {
  isin: null,
  error: null,
  products: null,
  loading: false,
  derivativeType: DERIVATIVE_TYPES[0],
  leverage: 10,
  cap: CAPS[2],
  strike: STRIKES[2],
  duration: DURATIONS[0],
  factor: FACTORS[1],
  quickMode: true,
  productType: LeverageProductType.CALL,
  customLeverage: null,
  highlightedProduct: null,
};

export const derivativeSearchFeature = createFeature({
  name: DERIVATIVE_SEARCH_FEATURE_KEY,
  reducer: createReducer(
    initialState,
    on(DerivativeSearchActions.resetState, (): DerivativeSearchState => initialState),
    on(DerivativeSearchActions.setIsin, (state, { isin }): DerivativeSearchState => ({ ...state, isin })),
    on(DerivativeSearchActions.setCap, (state, { cap }): DerivativeSearchState => ({ ...state, cap })),
    on(DerivativeSearchActions.setStrike, (state, { strike }): DerivativeSearchState => ({ ...state, strike })),
    on(DerivativeSearchActions.setFactor, (state, { factor }): DerivativeSearchState => ({ ...state, factor })),
    on(DerivativeSearchActions.setDuration, (state, { duration }): DerivativeSearchState => ({ ...state, duration })),
    on(DerivativeSearchActions.setLeverage, (state, { leverage }): DerivativeSearchState => ({ ...state, leverage })),
    on(DerivativeSearchActions.setDerivativeType, (state, { derivativeType }): DerivativeSearchState => ({ ...state, derivativeType })),
    on(
      DerivativeSearchActions.setLongOrShort,
      (state, { leverageProductType }): DerivativeSearchState => ({ ...state, productType: leverageProductType }),
    ),
    on(DerivativeSearchActions.setQuickMode, (state, { quickMode }): DerivativeSearchState => ({ ...state, quickMode })),
    on(DerivativeSearchActions.loadProducts, (state): DerivativeSearchState => ({ ...state, error: null, loading: true })),
    on(
      DerivativeSearchApiActions.loadProductsSuccess,
      (state, { products, highlightedProduct }): DerivativeSearchState => ({
        ...state,
        products,
        loading: false,
        highlightedProduct,
      }),
    ),
    on(DerivativeSearchApiActions.loadProductsFailure, (state, { error }): DerivativeSearchState => ({ ...state, error, loading: false })),
  ),
});
